import { API_AUTH } from "./common";

const CauHinhApi = {
  getConfig: () => API_AUTH.get(`cau-hinh/config`, {}),
  getConfigSys: ({ loaiTaiSan }) => API_AUTH.get(`cau-hinh/config-sys`, {}),
  getConfigSys1: () => API_AUTH.get(`cau-hinh/config-sys`, {}),
  getConfigSys_LoaiTaiSan: ({ loaiTaiSan }) =>
    API_AUTH.get(`quanlytaisan/cau-hinh-tai-san?loaiTaiSan=${loaiTaiSan}`, {}),
  getConfigSys_LoaiTaiSan1: (loaiTaiSan) =>
    API_AUTH.get(`quanlytaisan/cau-hinh-tai-san?loaiTaiSan=${loaiTaiSan}`, {}),
  getConfigSys_TraGop: () => API_AUTH.get(`cau-hinh/config-sys-tragop`, {}),

  getCauHinhApiLink: () => API_AUTH.get(`cau-hinh/he-thong-api`, {}),

  getTimeServer: () => API_AUTH.get(`time-server`, {}),
};

export default CauHinhApi;
